<template>
  <div v-if="isActiveSection">
    <div v-if="!isMobileScreen" class="speakers-main-container">
      <div class="moderators" v-if="speakersList.moderators.length">
        <p class="s-heading">Moderators</p>
        <b-container class="speakers-container">
          <div
            class="speaker-row"
            v-for="{ id, details } in speakersList.moderators"
            :key="id"
          >
            <div class="speaker-photo-container">
              <img
                class="moderator-photo"
                :src="details.prof_pic"
                alt=""
              />
            </div>
            <div class="speaker-info-container pl-1">
              <router-link :to="{name: 'userProfilePage', params: { customerId: details.customer_id }}">
                <p class="speaker-username">{{ details.name }}</p>
              </router-link>
              <p class="speaker-position">{{ details.job_title }}</p>
              <p class="speaker-company" @click="goToCompany(details.company_id)">
                {{ details.company }}
              </p>
            </div>
          </div>
        </b-container>
      </div>
      <div class="keynote" v-if="speakersList.keynoteSpeakers.length">
        <p class="s-heading">Keynote Speakers</p>
        <b-container class="speakers-container">
          <div
            class="speaker-row"
            v-for="{ id, details } in speakersList.keynoteSpeakers"
            :key="id"
          >
            <div class="speaker-photo-container">
              <img
                class="moderator-photo"
                :src="details.prof_pic"
                alt=""
              />
            </div>
            <div class="speaker-info-container pl-1">
              <router-link :to="{name: 'userProfilePage', params: { customerId: details.customer_id }}">
                <p class="speaker-username">{{ details.name }}</p>
              </router-link>
              <p class="speaker-position">{{ details.job_title }}</p>
              <p class="speaker-company" @click="goToCompany(details.company_id)">
                {{ details.company }}
              </p>
            </div>
          </div>
        </b-container>
      </div>
      <div class="panelists" v-if="speakersList.panelist.length">
        <p class="s-heading">Panelists</p>
        <b-container class="speakers-container">
          <div
            class="speaker-row"
            v-for="{ id, details } in speakersList.panelist"
            :key="id"
          >
            <div class="speaker-photo-container">
              <img
                class="moderator-photo"
                :src="details.prof_pic"
                alt=""
              />
            </div>
            <div class="speaker-info-container pl-1">
              <router-link :to="{name: 'userProfilePage', params: { customerId: details.customer_id }}">
                <p class="speaker-username">{{ details.name }}</p>
              </router-link>
              <p class="speaker-position">{{ details.job_title }}</p>
              <p class="speaker-company" @click="goToCompany(details.company_id)">
                {{ details.company }}
              </p>
            </div>
          </div>
        </b-container>
      </div>
    </div>
    <div v-else class="speakers-accordion" role="tablist">
      <b-card v-if="speakersList.moderators.length" no-body class="mb-1">
        <b-card-header v-b-toggle.speakers-accordion-1 header-tag="header" role="tab">
          <div class="text-center">
            Moderators
            <i class="fas fa-chevron-up" />
            <i class="fas fa-chevron-down" />
          </div>
        </b-card-header>
        <b-collapse id="speakers-accordion-1" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <div
              class="speaker-row"
              v-for="speaker in speakersList.moderators"
              :key="speaker.id"
            >
              <div class="speaker-photo-container">
                <img
                  class="moderator-photo"
                  :src="speaker.details.prof_pic"
                  alt=""
                />
              </div>
              <div class="speaker-info-container pl-1">
                <router-link :to="{name: 'userProfilePage', params: { customerId: speaker.details.customer_id }}">
                  <p class="speaker-username">{{ speaker.details.name }}</p>
                </router-link>
                <p class="speaker-position">{{ speaker.details.job_title }}</p>
                <p class="speaker-company" @click="goToCompany(speaker.details.company_id)">
                  {{ speaker.details.company }}
                </p>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card v-if="speakersList.keynoteSpeakers.length" no-body class="mb-1">
        <b-card-header v-b-toggle.speakers-accordion-2 header-tag="header" role="tab">
          <div class="text-center">
            Keynote Speakers
            <i class="fas fa-chevron-up" />
            <i class="fas fa-chevron-down" />
          </div>
        </b-card-header>
        <b-collapse id="speakers-accordion-2" accordion="my-accordion" role="tabpanel">
          <div
            class="speaker-row"
            v-for="speaker in speakersList.keynoteSpeakers"
            :key="speaker.id"
          >
            <div class="speaker-photo-container" sm="4">
              <img
                class="moderator-photo"
                :src="speaker.details.prof_pic"
                alt=""
              />
            </div>
            <div class="speaker-info-container pl-1">
              <router-link :to="{name: 'userProfilePage', params: { customerId:  speaker.details.customer_id }}">
                <p class="speaker-username">{{ speaker.details.name }}</p>
              </router-link>
              <p class="speaker-position">{{ speaker.details.job_title }}</p>
              <p class="speaker-company" @click="goToCompany(speaker.details.company_id)">
                {{ speaker.details.company }}
              </p>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card v-if="speakersList.panelist.length" no-body class="mb-1">
        <b-card-header v-b-toggle.speakers-accordion-3 header-tag="header" role="tab">
          <div class="text-center">
            Panelists
            <i class="fas fa-chevron-up" />
            <i class="fas fa-chevron-down" />
          </div>
        </b-card-header>
        <b-collapse id="speakers-accordion-3" accordion="my-accordion" role="tabpanel">
          <div
            class="speaker-row"
            v-for="speaker in speakersList.panelist"
            :key="speaker.id"
          >
            <div class="speaker-photo-container" sm="4">
              <img
                class="moderator-photo"
                :src="speaker.details.prof_pic"
                alt=""
              />
            </div>
            <div class="speaker-info-container pl-1">
              <router-link :to="{name: 'userProfilePage',params: { customerId:  speaker.details.customer_id }}">
                <p class="speaker-username">{{ speaker.details.name }}</p>
              </router-link>
              <p class="speaker-position">{{ speaker.details.job_title }}</p>
              <p class="speaker-company" @click="goToCompany(speaker.details.company_id)">
                {{ speaker.details.company }}
              </p>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Speakers',
  computed: {
    ...mapGetters({
      speakersList: 'events/speakersList',
      event: 'events/fetchEvent',
      isMobileScreen: 'isMobileScreen',
    }),
    isActiveSection() {
      return this.event && this.event.available_sections ? this.event.available_sections.includes('speakers') : false;
    },
  },
  async mounted() {
    if (this.$route.params.eventId) {
      await this.fetchSpeakersList(this.$route.params.eventId);
    }
  },
  methods: {
    ...mapActions({
      fetchSpeakersList: 'events/fetchSpeakersList',

    }),
    goToCompany(id) {
      if (id) {
        this.$router.push({ name: 'companyProfile', params: { companyId: id } });
      }
    },
  },
};
</script>

<style scoped>

.speakers-main-container {
    margin-top: 11px;
}

.speakers-main-container>div {
  border-radius: 0 10px 10px 10px;
  margin-bottom: 10px;
}
.speakers-container {
  background: white;
  padding: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  border-radius: 0 0 10px 10px;
}
.speaker-row {
  border-left: 0;
  height: 62px;
  display: grid;
  grid-template-columns: 62px 1fr;
}
.moderator-photo {
  width: 60px;
  height: 60px;
  object-fit: cover;
}
p {
  margin: 2px 0;
}
.speaker-photo-container {
  padding: 0;
  max-width: 60px;
}
.speaker-info-container {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: center;
    align-items: flex-start;
}
.speaker-info-container > p {
  line-height: 10px;
  font-size: 11px;
  padding-top: 0px;
}
.speaker-info-container a{
  font-size: 13px;
  color:#000;
  line-height: 11px;
}
.speaker-username {
  font-weight: bold;
  text-transform: capitalize;
  margin-top: 3px;
  cursor: pointer;
}
.speaker-position {
  text-transform: capitalize;
  color: #333333;
}
.speaker-company {
  color: #bd9d5f;
  text-transform: capitalize;
  cursor: pointer;
}
.s-heading {
  color: #bd9d5f;
  text-transform: uppercase;
  font-size: 14px;
  padding: 10px 16px;
  border-radius: 0 10px 0 0;
  margin-bottom: 1px;
  background-color: #ffffff;
}
@media (max-width: 1024px) {
  .speakers-container {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
  .speakers-accordion>.card {
    border-radius: 0 10px 10px 10px;
    overflow: hidden;
  }
  .speakers-accordion>.card>.card-header>div {
    font-size: 13px;
  }
  .speakers-accordion>.card>.collapse>.card-body {
    padding: 0;
  }
  .speakers-accordion .speaker-row {
    border: 1px solid #ebebeb;
    border-left: 0;
    height: 52px;
    display: grid;
    grid-template-columns: 52px 1fr;
  }
  .moderator-photo {
    width: 52px;
    height: 52px;
    object-fit: fill;
    border-radius: 0 8px 10px 10px;
  }
  .speaker-info-container a {
    font-size: 11px;
  }
  .speaker-info-container > p {
    line-height: 12px;
    font-size: 9px;
    padding-top: 0;
  }
  .card > header i {
    position: absolute;
    top: 16px;
    right: 20px;
  }
  header .fa-chevron-up {
    display: inline-block;
  }
  header .fa-chevron-down {
    display: none;
  }
  .card > .collapsed .fa-chevron-down {
    display: inline-block;
  }
  .card > .collapsed .fa-chevron-up {
    display: none;
  }
  .card-header {
    background-color: #fff;
  }
  .speaker-row .moderator-photo {
    border-radius: 0;
  }
}
</style>
